export const iconFontAwesomeCodingFolderOpen = (
	<i className="fa-solid fa-folder-open"></i>
);
